/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurvey } from './DataSurvey';
import {
    DataSurveyFromJSON,
    DataSurveyFromJSONTyped,
    DataSurveyToJSON,
    DataSurveyToJSONTyped,
} from './DataSurvey';

/**
 * 
 * @export
 * @interface PaginatedDataSurveyList
 */
export interface PaginatedDataSurveyList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataSurveyList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataSurveyList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DataSurvey>}
     * @memberof PaginatedDataSurveyList
     */
    results: Array<DataSurvey>;
}

/**
 * Check if a given object implements the PaginatedDataSurveyList interface.
 */
export function instanceOfPaginatedDataSurveyList(value: object): value is PaginatedDataSurveyList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDataSurveyListFromJSON(json: any): PaginatedDataSurveyList {
    return PaginatedDataSurveyListFromJSONTyped(json, false);
}

export function PaginatedDataSurveyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDataSurveyList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(DataSurveyFromJSON)),
    };
}

export function PaginatedDataSurveyListToJSON(json: any): PaginatedDataSurveyList {
    return PaginatedDataSurveyListToJSONTyped(json, false);
}

export function PaginatedDataSurveyListToJSONTyped(value?: PaginatedDataSurveyList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DataSurveyToJSON)),
    };
}

